
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ThemeToggle extends Vue {
  mounted() {
    // Load saved theme preference from localStorage
    console.log("this.$vuetify.theme", this.$vuetify.theme);
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      this.$vuetify.theme.dark = savedTheme === "dark";
    }
  }

  toggleTheme(): void {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    // Save preference to localStorage
    localStorage.setItem("theme", this.$vuetify.theme.dark ? "dark" : "light");
  }

  get themeIcon(): string {
    return this.$vuetify.theme.dark
      ? "mdi-white-balance-sunny"
      : "mdi-weather-night";
  }

  get themeTooltip(): string {
    return this.$vuetify.theme.dark
      ? "Zum Hellmodus wechseln"
      : "Zum Dunkelmodus wechseln";
  }
}
